import { axiosClient } from "../axios";

export function authorize(email, password) {
  const payload = { email, password };
  return axiosClient.post(`/api/auth/login`, payload);
}

export function requestPassword(email) {
  return axiosClient.post(`/api/auth/password/request`, email);
}

export function requestPasswordValidate(email, token) {
  const payload = {
    email,
    password: token,
  };
  return axiosClient.post(`/api/auth/password/request/validate`, payload);
}

export function validateRegistrationToken(token, newPassword) {
  const params = new URLSearchParams({ token });
  return axiosClient.post(`/api/auth/registration/validate?${params}`, {
    password: newPassword,
  });
}
